export default __webpack_public_path__ + "static/media/Bank-documentation.a8309b91.md";